import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ForgetPasswordService } from 'src/services/forgetPasswordService';
import { ToasterService } from '../_services/toaster.service';
import { Title } from '@angular/platform-browser';
import { NiceScrollService } from '../_services/nice-scroll.service';
declare var jquery: any;
declare var $: any;
@Component({
    selector: 'app-forget-password',
    templateUrl: './forget-password.component.html',
    styleUrls: ['./forget-password.component.css'],
    standalone: false
})
export class ForgetPasswordComponent implements OnInit {

  constructor(private forgetPasswordService: ForgetPasswordService,
              private tostrService: ToasterService, private title: Title,
              private niceScroll: NiceScrollService
              ) {
             //   niceScroll.scrollToTop();
              }

  Email: string;
  ngOnInit() {
    this.title.setTitle('Forgot Password | pakmatti.com');
  }

  SaveBtnClick() {
    $('body').addClass('loading').loader('show', { overlay: true });
    this.forgetPasswordService.PostService('ForgotPassword', { EmailAddress: this.Email }).subscribe(response => {
      if (response.IsSuccess) {
        this.tostrService.Info(response.Message);
      } else {
        this.tostrService.Error(response.Message);
      }
      $('body').removeClass('loading').loader('hide');
    });
  }
}
